export default __webpack_public_path__ + "static/media/supper_apps_m3.949eae0c.png";